import { createSlotRecipe } from './runtime.js';

const videoPlayerConfig = {"name":"videoPlayer","slots":["root","shell","mediaFrame","chapterTimeSlider","chapterSegments","chapterSegment","previewBubble","previewImage","previewLabel","transcript","transcriptCloseButton","transcriptCue","transcriptCueContent"],"variantMap":{"transcriptCueActive":["false","true"]}}

export const videoPlayer = /* @__PURE__ */ createSlotRecipe(videoPlayerConfig)